(() => {
  let activeCurrency = String(window.Shopify?.currency?.active || '').trim().toUpperCase();

  const detectCurrencyFromPrice = () => {
    const sample = String(document.querySelector('[data-orv-price]')?.textContent || '').replace(/\u00A0/g, ' ');
    const code = sample.match(/\b(AED|SAR|USD|EUR|GBP|PKR)\b/i);
    if (code) return code[1].toUpperCase();
    if (/\bDhs\.?\b/i.test(sample)) return 'AED';
    if (/\b(?:Rs\.?|PKR)\b/i.test(sample)) return 'PKR';
    return '';
  };

  const cartCurrency = async () => {
    const fallback = activeCurrency || detectCurrencyFromPrice();
    try {
      const root = String(window.Shopify?.routes?.root || '/');
      const cartUrl = `${root.endsWith('/') ? root : `${root}/`}cart.js`;
      const response = await fetch(cartUrl, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (!response.ok) return fallback;
      const cart = await response.json();
      return String(cart?.currency || fallback || '').trim().toUpperCase();
    } catch (_) {
      return fallback;
    }
  };

  const normalizeMoneyText = (value) => {
    if (!activeCurrency) return String(value || '');
    let text = String(value || '').replace(/\u00A0/g, ' ');
    text = text.replace(/\b(?:AED|SAR|USD|EUR|GBP|PKR)\b\s*/gi, `${activeCurrency} `);
    text = text.replace(/\b(?:Rs\.?|Dhs\.?)\s*/gi, `${activeCurrency} `);
    return text.replace(/\s{2,}/g, ' ').trim();
  };

  const normalizeBundleCurrency = (scope = document) => {
    if (!activeCurrency) return;
    const root = scope.querySelector?.('.orv-product') || (scope.matches?.('.orv-product') ? scope : document.querySelector('.orv-product'));
    if (!root) return;
    root.querySelectorAll('.orv-bundle-price strong, .orv-bundle-price del, .orv-bundle-saving').forEach((node) => {
      const next = normalizeMoneyText(node.textContent);
      if (next && next !== node.textContent) node.textContent = next;
    });
    root.querySelectorAll('[data-orv-bundle]').forEach((row) => {
      ['basePrice', 'baseCompare', 'saving'].forEach((key) => {
        if (!row.dataset[key]) return;
        const next = normalizeMoneyText(row.dataset[key]);
        if (next !== row.dataset[key]) row.dataset[key] = next;
      });
    });
    root.querySelectorAll('input[name="properties[Bundle offer]"]').forEach((input) => {
      const next = normalizeMoneyText(input.value);
      if (next !== input.value) input.value = next;
    });
  };

  const setupObserver = () => {
    const productRoot = document.querySelector('.orv-product');
    if (!productRoot || productRoot.dataset.orvCurrencyObserver === 'true') return;
    productRoot.dataset.orvCurrencyObserver = 'true';
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        normalizeBundleCurrency(productRoot);
      });
    });
    observer.observe(productRoot, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['data-base-price', 'data-base-compare', 'data-saving'] });
  };

  const init = async () => {
    activeCurrency = await cartCurrency();
    if (!activeCurrency) return;
    normalizeBundleCurrency();
    setupObserver();
    window.setTimeout(() => normalizeBundleCurrency(), 150);
    window.setTimeout(() => normalizeBundleCurrency(), 700);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', () => window.setTimeout(init, 0));
})();